module.exports = __webpack_public_path__ + "assets/img/vue_starter_zip_download.aa50d853.jpg";